﻿import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ld-decision-info-box',
  templateUrl: 'decision-info-box.template.html',
  styleUrls: [ './decision-info-box.style.scss' ]
})
export class DecisionInfoBoxComponent {
  @Input() public optionTitle: string;
  @Input() public buttonText: string;

  // used to highlight the banner as purple if true
  @Input() public isSuggested: boolean;

  public cssClasses: string[];

  @Output() onDecisionClick: EventEmitter<null> = new EventEmitter<null>();

  public onClick($event) {
    $event.preventDefault();
    this.onDecisionClick.emit();
  }
}
